import { render, staticRenderFns } from "./CommonData.vue?vue&type=template&id=71272bd6&scoped=true&"
import script from "./CommonData.vue?vue&type=script&lang=js&"
export * from "./CommonData.vue?vue&type=script&lang=js&"
import style0 from "./CommonData.vue?vue&type=style&index=0&id=71272bd6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71272bd6",
  null
  
)

export default component.exports